module.exports = "/_next/static/images/mugitoolive_in-0ee62e626dcbd5af7d7c3c2217e167dd.jpg";